import { Button } from '@brighterion/br-ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { handleKeyEvent, handleOnClickEvent } from 'Utils';
import { DateService } from 'Services';
import { shouldShowMerchants } from 'Selectors';
import { EventNames, EventTypes, trackEvent } from '@brighterion/insights';
import DeleteSimulationModal from '../../../components/DeleteSimulationModal/DeleteSimulationModal';
import styles from '../ViewSimulation.css';

type Props = {
    activeSimulationData: SimulationApiResponseObj;
};

const DeleteSimulation = ({ activeSimulationData }: Props) => {
    const { t } = useTranslation();
    const [deleteSimulationIsOpen, setDeleteSimulationIsOpen] = useState(false);
    const history = useHistory();
    const duration = DateService.getDuration(activeSimulationData.start, activeSimulationData.end);

    return (
        <>
            <Button
                className={styles.deleteSimulationBtn}
                variant='secondary'
                size='small'
                data-testid='delete-btn'
                onClick={handleOnClickEvent(() => setDeleteSimulationIsOpen(true))}
                onKeyDown={handleKeyEvent(() => setDeleteSimulationIsOpen(true))}
            >
                {t('Delete Simulation')}
            </Button>
            <DeleteSimulationModal
                isOpen={deleteSimulationIsOpen}
                onClose={() => setDeleteSimulationIsOpen(false)}
                rowValues={{
                    id: activeSimulationData?.id,
                    createdAt: activeSimulationData?.createdAt,
                    createdBy: activeSimulationData?.createdBy,
                    start: activeSimulationData?.start,
                    scope: shouldShowMerchants() ? t('All Merchants') : '',
                    sandbox: t(activeSimulationData?.sandbox),
                    simulationType: activeSimulationData?.simulationType,
                    duration,
                    compare: !!activeSimulationData?.compare?.length
                }}
                onSuccess={() => {
                    trackEvent({
                        eventType: EventTypes.track,
                        eventName: EventNames.click,
                        payload: {
                            clickIdentifier: 'View Simulation - Delete Simulation',
                            text: 'Delete Opened Simulation'
                        }
                    });
                    history.push('/simulations');
                }}
            />
        </>
    );
};

export default DeleteSimulation;
